import { render, staticRenderFns } from "./Subscriptions.vue?vue&type=template&id=48852bdb&scoped=true"
import script from "./Subscriptions.vue?vue&type=script&lang=js"
export * from "./Subscriptions.vue?vue&type=script&lang=js"
import style0 from "./Subscriptions.vue?vue&type=style&index=0&id=48852bdb&prod&lang=scss"
import style1 from "./Subscriptions.vue?vue&type=style&index=1&id=48852bdb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48852bdb",
  null
  
)

export default component.exports